export const translationKeys = {
  ariaLabel: 'hamburgerOverlay_ariaLabel',
};

export const dataHooks = {
  dialog: 'hamburger-overlay-dialog',
  root: 'hamburger-overlay-root',
};

export const firstFocusableElementSelector =
  'a[href], button, input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
